import React, { Component, Fragment } from "react";
import Loader from "./Loader";
import ContentLoader from 'react-content-loader';


class TransactionDetailsLoader extends Component {
  render() {
    return (
      <Fragment>
        <Fragment>
          <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
            <h1 className="small"><i className="fas fa-arrow-left" />My Transactions</h1>
            {/* card for registered courses display  */}
            <div className="row no-gutters">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row no-gutters">
                      <div className="col-xs-6 col-sm-6 col-md-12 col-lg-6 p-2">Transaction Details</div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="row m-0">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 order-2 order-sm-2 order-md-2 order-lg-1 order-xl-1 p-0 border-right">
                        <div className="payment-details">
                          <div className="detail-container">
                            <p className="text">Total Amount Paid</p>
                            <div className="amount">
                              <Loader width='300' height='40' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="detail-container">
                            <p className="text">Payment Date</p>
                            <div className="amount text-light"><Loader width='300' height='40' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="detail-container">
                            <p className="text">Payment Status</p>
                            <div className="amount text-light">
                              <div className="status mb-5"><i> <Loader width='250' height='20' /></i></div>
                            </div>
                          </div>
                        </div>
                        {/* button */}
                        <div className="footer">
                          {/* subtitute active class for disabled to either make button active or inactive */}
                          <button className="position-absolute fixed-bottom btn w-100 btn-primary-big btn-border-radius-payment active"><Loader width="350" height="30" pcolor="#00ba12" /></button>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 order-1 order-sm-1 order-md-1 order-lg-2 order-xl-2 p-0">
                        <div className="payment-details">
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Payment Details</div>
                            <div className="col-lg-6 text bold"><Loader width='250' height='15' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Level</div>
                            <div className="col-lg-6 text bold"><Loader width='250' height='15' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">RRR</div>
                            <div className="col-lg-6 text bold"><Loader width='250' height='15' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Transaction Ref.</div>
                            <div className="col-lg-6 text bold"><Loader width='250' height='15' /></div>
                          </div>
                          <hr className="separator" />
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text">Total Payment</div>
                            <div className="col-lg-6 text bold"><Loader width='250' height='15' /></div>
                          </div>
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text-misc"><Loader width='250' height='25' /></div>
                            <div className="col-lg-6 text-misc"><Loader width='250' height='15' /></div>
                          </div>
                          <div className="row detail-container m-0">
                            <div className="col-lg-6 text-misc">Other Charges</div>
                            <div className="col-lg-6 text-misc"><Loader width='250' height='15' /></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* card for outstanding fees */}
              </div>
            </div>
            {/* end card for news display   */}
          </main>

        </Fragment>
      </Fragment>
    );
  }
}

export default TransactionDetailsLoader;
